import { defineEvent } from '../types/event';
export var PDP_BREADCRUMBS_LINK_CLICK = defineEvent({
    platforms: [
        {
            name: 'Optimizely',
            alias: 'Clicks_On_PDP_Breadcrumbs_Link'
        }
    ]
});
